import { error } from '@whizz/logger';
import { useI18n, I18nProvider } from '@whizz/react-i18n';
import React, { memo, PureComponent } from 'react';
import { makeStyles, Container as Container$1, Card, CardContent, Typography, CardActions, Button } from '@material-ui/core';
import { Refresh } from '@material-ui/icons';

var ErrorBoundary$5 = {
	LINE1: "An error report has been sent over to our techies who will get this fixed up.",
	LINE2: "In the meantime, please reload the page and try again.",
	RELOAD: "Reload",
	TITLE: "Whoops! Something went wrong."
};
var enGb = {
	ErrorBoundary: ErrorBoundary$5
};

var ErrorBoundary$4 = {
	LINE1: "Se envió un reporte de error a nuestros técnicos que arreglarán esto.",
	LINE2: "Por lo mientras, actualiza esta página e intenta de nuevo.",
	RELOAD: "Actualizar",
	TITLE: "¡Ups! Algo salió mal."
};
var esMx = {
	ErrorBoundary: ErrorBoundary$4
};

var ErrorBoundary$3 = {
	LINE1: "Un rapport d'erreur a été envoyé à nos techniciens qui l'étudieront dans les meilleurs délais.",
	LINE2: "En attendant, merci d'actualiser la page pour réessayer.",
	RELOAD: "Actualiser",
	TITLE: "Oups ! Il y a eu un problème."
};
var frCd = {
	ErrorBoundary: ErrorBoundary$3
};

var ErrorBoundary$2 = {
	LINE1: "Отчёт был отправлен в Службу техподдержки.",
	LINE2: "Нажми внизу, чтобы обновить страницу и попробовать ещё раз.",
	RELOAD: "Обновить страницу",
	TITLE: "Ой! Произошла ошибка."
};
var ruRu = {
	ErrorBoundary: ErrorBoundary$2
};

var ErrorBoundary$1 = {
	LINE1: "Ripoti ya makosa imetumwa kwa wataalam wetu wa kiufundi ambao watafanya marekebisho.",
	LINE2: "Kwa sasa, tafadhali pakia upya ukurasa na ujaribu tena.",
	RELOAD: "Pakia upya",
	TITLE: "Lo! Kuna kitu kimeenda vibaya."
};
var swKe = {
	ErrorBoundary: ErrorBoundary$1
};

var ErrorBoundary = {
	LINE1: "รายงานข้อผิดพลาดถูกส่งไปที่ทีมเทคนิคของเราแล้ว ซึ่งจะดำเนินการแก้ไขต่อไป",
	LINE2: "ระหว่างที่รอการแก้ไข กรุณาลองโหลดหน้านี้ใหม่อีกครั้ง",
	RELOAD: "โหลดใหม่",
	TITLE: "อ๊ะ! มีบางอย่างผิดพลาด"
};
var thTh = {
	ErrorBoundary: ErrorBoundary
};

const translations = {
    'en-gb': enGb,
    'es-mx': esMx,
    'fr-cd': frCd,
    'ru-ru': ruRu,
    'sw-ke': swKe,
    'th-th': thTh,
};

const View = ({ debug = [], onReloadClick = () => undefined }) => {
    const classes = useStyles();
    const { translate } = useI18n();
    return (React.createElement(Container$1, { maxWidth: "sm", className: classes.root },
        React.createElement(Card, null,
            React.createElement(CardContent, null,
                React.createElement(Typography, { color: "error", variant: "h5" }, translate('ErrorBoundary.TITLE')),
                React.createElement(Typography, { variant: "body1", gutterBottom: true }, translate('ErrorBoundary.LINE1')),
                React.createElement(Typography, { variant: "body1" }, translate('ErrorBoundary.LINE2'))),
            React.createElement(CardActions, null,
                React.createElement(Button, { color: "primary", onClick: onReloadClick },
                    React.createElement(Refresh, { className: classes.icon }),
                    translate('ErrorBoundary.RELOAD')))),
        debug.map((line, index) => (React.createElement(Typography, { key: index, variant: "caption", component: "div", color: "textSecondary", align: "center", className: classes.debug }, line)))));
};
var View$1 = memo(View);
const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(6),
    },
    icon: {
        marginRight: theme.spacing(1),
    },
    debug: {
        marginTop: theme.spacing(1),
    },
}));

class Container extends PureComponent {
    constructor() {
        super(...arguments);
        this.state = {};
    }
    componentDidCatch(err, info) {
        error(err, info);
        this.setState({
            info,
            date: new Date(),
            error: err,
        });
    }
    render() {
        const { children, locale, onReloadClick } = this.props;
        const { date, error, info } = this.state;
        if (!error || !date || !info) {
            return children;
        }
        const debug = [`${date.toISOString().split('.')[0]}Z`, window.navigator.userAgent];
        return (React.createElement(I18nProvider, { locale: locale, translations: translations },
            React.createElement(View$1, { debug: debug, onReloadClick: onReloadClick })));
    }
}
Container.defaultProps = {
    onReloadClick: () => window.location.reload(),
};

export { Container as default };
